module.exports = __webpack_public_path__ + "static/img/James-Roberts.d3b3c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Roberts.jpg
// module id = oUju
// module chunks = 0